import React, { useState } from 'react';
import Stack from 'rsuite/Stack';
import { Uploader } from 'rsuite';
import { Loader } from 'rsuite';
import AttachmentIcon from '@rsuite/icons/Attachment';
import { Notification, useToaster } from 'rsuite';
import { getToken } from 'Components/_helpers/localstorage';

const uploaderStyles = {
  height: 200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

///Deprecated
export const CargaModulo = (props) => {
  const token = getToken();
  const headers = { 'Authorization': `Bearer ${token}` };
  const { actionUrl, uploaderMessage, fileUploaded, disabled } = props;

  const [loading, setLoading] = useState(false);
  const toaster = useToaster();

  return (
    <div>
      <Uploader
        action={actionUrl}
        draggable
        headers={headers}
        disabled={loading || disabled}
        accept=".txt, .json, .csv"
        name="files"
        fileListVisible={false}
        onSuccess={(res, f) => {
          res.forEach((r) => {
            toaster.push(
              <Notification type={r.estatus === 0 ? 'info' : 'error'} header={`DTE Manager`} closable>
                <p>{r.message}</p>
              </Notification>,
              {placement: 'topEnd'}
            );
          });
          setLoading(false);
          fileUploaded();
        }}
        onUpload={() => {
          setLoading(true);
        }}
      >
        <div style={uploaderStyles}>
          {loading ? (
            <Loader />
          ) : (
            <Stack direction="column">
              <AttachmentIcon style={{ fontSize: '4em', marginBottom: 10 }} />
              <span>Haz click o Arrastra aquí el archivo para cargarlo.</span>
              <span>Asegurate de estar dentro de la carpeta del tipo de DTE a procesar.</span>
              <span>{uploaderMessage}</span>
            </Stack>
          )}
        </div>
      </Uploader>
    </div>
  );
};
